export const ACTUAL_PAGE = "{{ACTUAL_PAGE}}";
export const FIRST_ITEM_IN_PAGE = "{{FIRST_ITEM_IN_PAGE}}";
export const LAST_ITEM_IN_PAGE = "{{LAST_ITEM_IN_PAGE}}";
export const TOTAL_ITEMS = "{{TOTAL_ITEMS}}";
export const TOTAL_PAGES = "{{TOTAL_PAGES}}";
export const TOTAL_PAGES_UNDEFINED = -1;
